import type { ReactNode } from "react";
import { Suspense } from "react";

import RouteFallback from "@/components/RouteFallback/RouteFallback";

import AuthNavActions from "../components/AuthNavActions/AuthNavActions";
import LanguageSwitcher from "../components/LanguageSwitcher/LanguageSwitcher";
import AppNavbar from "../components/Navbar/AppNavbar";
import OrgSwitcher from "../components/OrgSwitcher/OrgSwitcher";
import SeoHead from "../components/SeoHead/SeoHead";
import useNavItems from "../hooks/useNavItems";

interface AppShellProps {
  children: ReactNode;
  showLangSwitcher?: boolean;
}

function AppShell({ children, showLangSwitcher = false }: AppShellProps) {
  const navItems = useNavItems();

  return (
    <div className="App">
      <SeoHead />
      <AppNavbar
        navItems={navItems}
        beforeChildren={<OrgSwitcher />}
        mobileBeforeChildren={
          showLangSwitcher ? <LanguageSwitcher mobile /> : undefined
        }
        mobileChildren={<AuthNavActions />}
      />
      <main>
        <Suspense fallback={<RouteFallback />}>{children}</Suspense>
      </main>
    </div>
  );
}

export default AppShell;
